export const queryParams = () => {
    return window
        .location
        .search
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            let [key, value = true] = param.split('=');

            key = decodeURIComponent(key);
            value = decodeURIComponent(value);

            if (params[key] !== undefined) {
                if (!Array.isArray(params[key]))
                    params[key] = [ params[key] ]
                params[key].push(value)
            } else {
                params[key] = value;
            }

            return params;
        }, {});
};